(function() {
  const STORAGE_KEY = 'sfs-vat-mode';
  const COOKIE_KEY = 'sfs_vat_mode';

  function isValidMode(mode) {
    return mode === 'inc' || mode === 'ex';
  }

  function setStoredMode(mode) {
    if (!isValidMode(mode)) mode = 'ex';
    try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) {}
    try { sessionStorage.setItem(STORAGE_KEY, mode); } catch (e) {}
    try {
      document.cookie = COOKIE_KEY + '=' + encodeURIComponent(mode) + '; path=/; max-age=31536000; SameSite=Lax';
    } catch (e) {}
    try {
      document.documentElement.setAttribute('data-sfs-vat-mode', mode);
    } catch (e) {}
  }

  function getCookieMode() {
    try {
      const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_KEY + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function getStoredMode() {
    let savedMode = null;

    try { savedMode = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (!isValidMode(savedMode)) {
      try { savedMode = sessionStorage.getItem(STORAGE_KEY); } catch (e) {}
    }
    if (!isValidMode(savedMode)) savedMode = getCookieMode();
    if (!isValidMode(savedMode)) {
      try { savedMode = document.documentElement.getAttribute('data-sfs-vat-mode'); } catch (e) {}
    }

    return isValidMode(savedMode) ? savedMode : 'ex';
  }

  function getConfig() {
    return window.SFS_VAT_CONFIG || {
      rate: 0.20,
      pricesIncludeVat: false,
      moneyFormat: '£{{amount}}'
    };
  }

  function normaliseMoneyFormat(format) {
    if (!format || typeof format !== 'string') return '£{{amount}}';
    if (!format.includes('£')) format = '£' + format;
    return format;
  }

  function formatMoney(cents) {
    const config = getConfig();
    const moneyFormat = normaliseMoneyFormat(config.moneyFormat);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      let formatted = window.Shopify.formatMoney(cents, moneyFormat);
      if (formatted && !formatted.trim().startsWith('£')) {
        formatted = '£' + formatted.trim().replace(/^GBP\s*/i, '');
      }
      return formatted;
    }

    return '£' + (Number(cents || 0) / 100).toFixed(2);
  }

  function convertPrice(basePriceCents, showIncludingVat) {
    const config = getConfig();
    const rateMultiplier = 1 + Number(config.rate || 0);
    const baseIncludesVat = !!config.pricesIncludeVat;

    if (showIncludingVat) return baseIncludesVat ? basePriceCents : Math.round(basePriceCents * rateMultiplier);
    return baseIncludesVat ? Math.round(basePriceCents / rateMultiplier) : basePriceCents;
  }

  function getModeLabel(showIncludingVat) {
    return showIncludingVat ? 'Inc VAT' : 'Ex VAT';
  }

  function setToggleVisuals(mode) {
    const shouldShowIncVat = mode === 'inc';

    document.querySelectorAll('[data-vat-toggle-input]').forEach((toggle) => {
      toggle.checked = shouldShowIncVat;
      bindToggle(toggle);
    });

    document.querySelectorAll('[data-vat-toggle-text]').forEach((node) => {
      node.textContent = shouldShowIncVat ? 'Inc VAT' : 'Ex VAT';
    });
  }

  function updatePrices(modeOverride) {
    const mode = isValidMode(modeOverride) ? modeOverride : getStoredMode();
    const showIncludingVat = mode === 'inc';
    const modeLabel = getModeLabel(showIncludingVat);

    /* Important: do not save from the current checkbox state here.
       New pages render the checkbox unchecked by default, so saving here would
       overwrite the user's saved Inc VAT choice back to Ex VAT. */
    setToggleVisuals(mode);

    document.querySelectorAll('[data-vat-price]').forEach((el) => {
      const basePrice = parseInt(el.getAttribute('data-vat-price'), 10);
      if (Number.isNaN(basePrice)) return;

      const formattedPrice = formatMoney(convertPrice(basePrice, showIncludingVat));
      const isUnitPrice = el.closest('.unit-price') !== null;

      if (isUnitPrice) {
        el.textContent = formattedPrice;
        return;
      }

      el.innerHTML = '<span class="sfs-price-money">' + formattedPrice + '</span> <span class="sfs-vat-price-label">' + modeLabel + '</span>';
      el.setAttribute('data-vat-mode-label', modeLabel);
    });
  }

  function bindToggle(toggle) {
    if (!toggle || toggle.dataset.vatToggleBound === 'true') return;
    toggle.dataset.vatToggleBound = 'true';

    toggle.addEventListener('change', function() {
      const mode = toggle.checked ? 'inc' : 'ex';
      setStoredMode(mode);
      setToggleVisuals(mode);
      updatePrices(mode);
    });
  }

  function initVatToggle() {
    const mode = getStoredMode();
    setToggleVisuals(mode);
    updatePrices(mode);
  }

  // Set the saved mode as early as possible for CSS/hooks.
  try { document.documentElement.setAttribute('data-sfs-vat-mode', getStoredMode()); } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVatToggle);
  } else {
    initVatToggle();
  }

  document.addEventListener('shopify:section:load', initVatToggle);
  window.addEventListener('pageshow', initVatToggle);
  window.SFSUpdateVatPrices = function() { updatePrices(getStoredMode()); };
  window.SFSInitVatToggle = initVatToggle;

  // Re-apply after Shopify AJAX product/section reloads without overwriting storage.
  setInterval(function() {
    updatePrices(getStoredMode());
  }, 700);

  document.addEventListener('change', function(event) {
    if (event.target && event.target.matches('variant-selects select, variant-radios input')) {
      setTimeout(function() { updatePrices(getStoredMode()); }, 80);
    }
  });
})();
